module.exports = __webpack_public_path__ + "static/media/cp_usuario.3e801910.jpg";